module.exports = __webpack_public_path__ + "media/images/filter-gray-a39fbcc36035860ff628e6a44fdc23e9.svg";